<template>
  <div id="info" class="message" :class="['-' + type]">
    <div v-if="icon" class="message__icon">
      <iconInfo v-if="type === 'info'" />
      <iconError v-if="type === 'error'" />
      <iconSuccess v-if="type === 'success'" />
    </div>
    <div class="message__text" data-cy="message-text">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import iconInfo from "@/components/Icons/iconMessageInfo";
import iconError from "@/components/Icons/iconMessageError";
import iconSuccess from "@/components/Icons/iconMessageSuccess";

export default {
  components: {
    iconInfo,
    iconError,
    iconSuccess
  },
  props: {
    type: {
      type: String,
      default: "success"
    },
    icon: {
      type: Boolean,
      default: true
    }
  }
};
</script>
